// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"cf349eb9","947":"fd6f9515"}[chunkId] + ".chunk.js";
};